import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import TypeOfOrderSelector from 'components/form/TypeOfOrderSelector/container';
import media from 'styled-media-query';

export default styled(TypeOfOrderSelector)`
  fieldset {
    display: flex;
    justify-content: space-between;
    ${media.lessThan('medium')`
    display: grid;
    grid-template-columns: 1fr 1fr;
    `}

    margin-bottom: ${gridSizes('L')};
    label {
      margin-right: ${gridSizes('L')};
      border: none;
      padding: 0;
      background: none !important;
      div {
        background: none !important;
      }

      &:hover {
        background: none !important;
        div {
          background: none !important;
        }
      }
    }
  }
`;
